enum EnumEventSport {
    WALKING = 'WALKING',
    NORDIC_WALKING = 'NORDIC_WALKING',
}
  
export default EnumEventSport;
  